import { registerDecorator } from 'class-validator';
/**
 * Validates if a related value is truthy then the value is truthy when provided with an evaluator.
 * @param property A related value to evaluate if truthy
 * @param evaluator Comparator for the provided value
 * @param validationOptions Class validator options
 */
export function IsTruthyWhen(property, evaluator, validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isTruthyWhen',
            target: object.constructor,
            propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                /* eslint-disable @typescript-eslint/no-explicit-any */
                validate(value, args) {
                    const [relatedPropertyName] = args.constraints;
                    const relatedValue = args.object[relatedPropertyName];
                    return !!relatedValue === evaluator ? !!value || !!value === evaluator : true;
                },
                /* eslint-enable @typescript-eslint/no-explicit-any */
            },
        });
    };
}
